import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useCouponPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();
  const isCourseDetailPage = location.pathname.startsWith('/course/');

  useEffect(() => {
    // Disable popup completely - always return false
    setShowPopup(false);
  }, [isCourseDetailPage]);

  return { showPopup: false, setShowPopup };
};

export default useCouponPopup; 